import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

let NEXT_ID = 1;

export type ToastTipo = 'sucesso' | 'erro' | 'aviso' | 'info';
export interface ToastPayload { tipo: ToastTipo; titulo: string; mensagem: string; duration?: number; }

@Injectable({ providedIn: 'root' })
export class ToastService {
    private _events$ = new Subject<ToastPayload>();
    events$ = this._events$.asObservable();
    readonly id = NEXT_ID++;

    show(tipo: ToastTipo, titulo: string, mensagem: string, duration?: number) {
        this._events$.next({ tipo, titulo, mensagem, duration });
    }
}
